import React, { FC } from 'react';
import { Box, Link, Typography } from '@material-ui/core';
import viewMoreCTAStyles from './viewMoreCTAStyles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import Translation from '../../../../common/components/translation/Translation';

export interface IViewMoreCtaProps {
  onClick: () => void;
  opened?: boolean;
  dataTest?: string;
}

const ViewMoreCta: FC<IViewMoreCtaProps> = ({ onClick, opened, dataTest }) => {
  const styles = viewMoreCTAStyles();

  return (
    <Box data-extended-slide={opened} display="flex" justifyContent="center" width={1} data-test={dataTest}>
      <Link onClick={onClick} className={styles.cta}>
        <Typography component="span">
          {opened ? (
            <Translation id="trans__configurator__variants_page__hide_features_link" />
          ) : (
            <Translation id="trans__configurator__variants_page__showMore_features_link" />
          )}
        </Typography>
        {opened ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </Link>
    </Box>
  );
};

export default ViewMoreCta;
